module.exports = __webpack_public_path__ + "static/media/rio-creative-conference.7c9a1c31.webp";